export interface AgeRangeData {
  total: number;
  change: number;
  organic_streams: {
    library: number;
    search: number;
  };
}

export interface DemographicData {
  total_streams: number;
  '13–17': AgeRangeData;
  '18–24': AgeRangeData;
  '24–34': AgeRangeData;
  '35–44': AgeRangeData;
  '45–54': AgeRangeData;
  '55–64': AgeRangeData;
  '65+': AgeRangeData;
}

export interface DemographicStreamData {
  isrc: string;
  total_streams: number;
  streams_by_demographics: {
    all: DemographicData;
    female: DemographicData;
    male: DemographicData;
    'non-binary': DemographicData;
    unknown: DemographicData;
  };
}

export interface DSPData {
  source: string;
  total: number;
  change: number;
}

export interface DSPStreamData {
  family_id: string;
  total_streams: number;
  streams_by_dsp: DSPData[];
}

export const mockDemographicStreamingData: DemographicStreamData = {
  isrc: 'USNLR1300366',
  total_streams: 12500000,
  streams_by_demographics: {
    all: {
      total_streams: 5000000,
      '13–17': {
        total: 750000,
        change: -50000,
        organic_streams: {
          library: 500000,
          search: 250000,
        },
      },
      '18–24': {
        total: 1250000,
        change: 100000,
        organic_streams: {
          library: 400000,
          search: 850000,
        },
      },
      '24–34': {
        total: 1000000,
        change: 50000,
        organic_streams: {
          library: 660000,
          search: 340000,
        },
      },
      '35–44': {
        total: 900000,
        change: -25000,
        organic_streams: {
          library: 500000,
          search: 400000,
        },
      },
      '45–54': {
        total: 600000,
        change: -50000,
        organic_streams: {
          library: 300000,
          search: 300000,
        },
      },
      '55–64': {
        total: 400000,
        change: -75000,
        organic_streams: {
          library: 150000,
          search: 250000,
        },
      },
      '65+': {
        total: 100000,
        change: 0,
        organic_streams: {
          library: 70000,
          search: 30000,
        },
      },
    },
    female: {
      total_streams: 6000000,
      '13–17': {
        total: 400000,
        change: -35000,
        organic_streams: {
          library: 200000,
          search: 200000,
        },
      },
      '18–24': {
        total: 1500000,
        change: 125000,
        organic_streams: {
          library: 600000,
          search: 900000,
        },
      },
      '24–34': {
        total: 1250000,
        change: 75000,
        organic_streams: {
          library: 700000,
          search: 550000,
        },
      },
      '35–44': {
        total: 1000000,
        change: -15000,
        organic_streams: {
          library: 500000,
          search: 500000,
        },
      },
      '45–54': {
        total: 750000,
        change: -40000,
        organic_streams: {
          library: 300000,
          search: 450000,
        },
      },
      '55–64': {
        total: 600000,
        change: -50000,
        organic_streams: {
          library: 200000,
          search: 400000,
        },
      },
      '65+': {
        total: 500000,
        change: 15000,
        organic_streams: {
          library: 300000,
          search: 200000,
        },
      },
    },
    male: {
      total_streams: 4000000,
      '13–17': {
        total: 350000,
        change: -15000,
        organic_streams: {
          library: 150000,
          search: 200000,
        },
      },
      '18–24': {
        total: 1000000,
        change: 75000,
        organic_streams: {
          library: 300000,
          search: 700000,
        },
      },
      '24–34': {
        total: 900000,
        change: 40000,
        organic_streams: {
          library: 500000,
          search: 400000,
        },
      },
      '35–44': {
        total: 750000,
        change: -10000,
        organic_streams: {
          library: 300000,
          search: 450000,
        },
      },
      '45–54': {
        total: 500000,
        change: -25000,
        organic_streams: {
          library: 200000,
          search: 300000,
        },
      },
      '55–64': {
        total: 300000,
        change: -40000,
        organic_streams: {
          library: 100000,
          search: 200000,
        },
      },
      '65+': {
        total: 50000,
        change: -10000,
        organic_streams: {
          library: 20000,
          search: 30000,
        },
      },
    },
    'non-binary': {
      total_streams: 1500000,
      '13–17': {
        total: 150000,
        change: 5000,
        organic_streams: {
          library: 50000,
          search: 100000,
        },
      },
      '18–24': {
        total: 500000,
        change: 50000,
        organic_streams: {
          library: 300000,
          search: 200000,
        },
      },
      '24–34': {
        total: 400000,
        change: 25000,
        organic_streams: {
          library: 200000,
          search: 200000,
        },
      },
      '35–44': {
        total: 250000,
        change: 0,
        organic_streams: {
          library: 100000,
          search: 150000,
        },
      },
      '45–54': {
        total: 100000,
        change: -5000,
        organic_streams: {
          library: 50000,
          search: 50000,
        },
      },
      '55–64': {
        total: 75000,
        change: -10000,
        organic_streams: {
          library: 25000,
          search: 50000,
        },
      },
      '65+': {
        total: 25000,
        change: -5000,
        organic_streams: {
          library: 10000,
          search: 15000,
        },
      },
    },
    unknown: {
      total_streams: 1000000,
      '13–17': {
        total: 100000,
        change: 0,
        organic_streams: {
          library: 50000,
          search: 50000,
        },
      },
      '18–24': {
        total: 300000,
        change: 15000,
        organic_streams: {
          library: 100000,
          search: 200000,
        },
      },
      '24–34': {
        total: 250000,
        change: 5000,
        organic_streams: {
          library: 100000,
          search: 150000,
        },
      },
      '35–44': {
        total: 150000,
        change: -2500,
        organic_streams: {
          library: 50000,
          search: 100000,
        },
      },
      '45–54': {
        total: 100000,
        change: -5000,
        organic_streams: {
          library: 50000,
          search: 50000,
        },
      },
      '55–64': {
        total: 75000,
        change: -5000,
        organic_streams: {
          library: 25000,
          search: 50000,
        },
      },
      '65+': {
        total: 25000,
        change: -2500,
        organic_streams: {
          library: 10000,
          search: 15000,
        },
      },
    },
  },
};

export const mockDSPStreamingData: DSPStreamData = {
  family_id: 'abc123',
  total_streams: 10000000,
  streams_by_dsp: [
    {
      source: 'spotify',
      total: 4700000,
      change: +100000,
    },
    {
      source: 'apple',
      total: 2100000,
      change: -100000,
    },
    {
      source: 'amazon',
      total: 1200000,
      change: +100000,
    },
    {
      source: 'youtube',
      total: 1000000,
      change: -100000,
    },
    {
      source: 'tidal',
      total: 300000,
      change: -100000,
    },
    {
      source: 'other',
      total: 700000,
      change: -100000,
    },
  ],
};

export const genderNames: string[] = [
  'All genders',
  'Female',
  'Male',
  'Non-binary',
  'Unknown',
];

export function getRandomSegments({
  total = 100,
  numSegments = 4,
}: {
  total?: number;
  numSegments?: number;
} = {}) {
  const segments = [];
  let sum = 0;

  for (let i = 0; i < numSegments - 1; i++) {
    const randomValue = Math.round(Math.random() * (total - sum));

    segments.push(randomValue);
    sum += randomValue;
  }

  segments.push(total - sum);

  return segments.sort(() => Math.random() - 0.5);
}
